var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 -1 .632 0 -52.4 461.58)",
    gradientUnits: "userSpaceOnUse",
    x1: 202,
    x2: 202,
    xlinkHref: "#lg1",
    y1: 164.307,
    y2: 193.735
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.716,
    x2: 61.716,
    xlinkHref: "#lg2",
    y1: 258,
    y2: 161.644
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(0 -1 .632 0 -52.4 461.58)",
    gradientUnits: "userSpaceOnUse",
    x1: 201.966,
    x2: 201.966,
    xlinkHref: "#lg1",
    y1: 338.168,
    y2: 367.595
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.565,
    x2: 171.565,
    xlinkHref: "#lg2",
    y1: 257.234,
    y2: 161.493
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(0 -1 .632 0 -52.4 461.58)",
    gradientUnits: "userSpaceOnUse",
    x1: 201.914,
    x2: 201.914,
    xlinkHref: "#lg1",
    y1: 602.219,
    y2: 631.647
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.435,
    x2: 338.435,
    xlinkHref: "#lg2",
    y1: 244.943,
    y2: 159.06
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(0 -1 .632 0 -52.4 461.58)",
    gradientUnits: "userSpaceOnUse",
    x1: 201.88,
    x2: 201.88,
    xlinkHref: "#lg1",
    y1: 776.08,
    y2: 805.508
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.308,
    x2: 448.308,
    xlinkHref: "#lg2",
    y1: 251.049,
    y2: 160.269
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(1 0 0 -1 1557.068 -4281.493)",
    gradientUnits: "userSpaceOnUse",
    x1: -1329.608,
    x2: -1274.527,
    xlinkHref: "#lg3",
    y1: -4602.56,
    y2: -4602.56
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 284.926,
    y2: 176.23
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 -.707 .707 .707 2078.846 -709.993)",
    gradientUnits: "userSpaceOnUse",
    x1: -2110.061,
    x2: -2150.064,
    xlinkHref: "#lg4",
    y1: -469.246,
    y2: -429.243
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 182,
    x2: 328.342,
    xlinkHref: "#lg5",
    y1: 59.331,
    y2: 59.331
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 73.129,
    y2: 118.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2808,
    stopColor: "#ed2819",
    stopOpacity: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7731,
    stopColor: "#d02726",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.087,
    x2: 287.063,
    xlinkHref: "#lg1",
    y1: 60.395,
    y2: 60.395
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 62.129,
    y2: 115.244
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.802,
    x2: 86.261,
    xlinkHref: "#lg5",
    y1: 129.383,
    y2: 177.841
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.135,
    x2: 179.738,
    xlinkHref: "#lg1",
    y1: 122.716,
    y2: 169.318
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.135,
    x2: 283.564,
    xlinkHref: "#lg5",
    y1: 133.716,
    y2: 171.144
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.802,
    x2: 379.749,
    xlinkHref: "#lg1",
    y1: 126.383,
    y2: 165.33
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.181,
    x2: 485.258,
    xlinkHref: "#lg5",
    y1: 125.67,
    y2: 172.747
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 51,
    x2: 51,
    xlinkHref: "#lg6",
    y1: 171.185,
    y2: 206.619
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 153,
    x2: 153,
    xlinkHref: "#lg2",
    y1: 174.518,
    y2: 213.874
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 171.185,
    y2: 206.619
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 357,
    x2: 357,
    xlinkHref: "#lg2",
    y1: 174.518,
    y2: 213.874
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 459,
    x2: 459,
    xlinkHref: "#lg6",
    y1: 171.185,
    y2: 206.619
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(0 1 1 0 1252.758 -1252.758)",
    gradientUnits: "userSpaceOnUse",
    x1: 1672.758,
    x2: 1729.757,
    xlinkHref: "#lg3",
    y1: -997.758,
    y2: -997.758
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 442.722,
    y2: 474.071
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(0 1 1 0 1252.758 -1252.758)",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.677,
    x2: 1762.758,
    y1: -997.758,
    y2: -997.758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 487.745,
    y2: 508.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.947,
    x2: 190.933,
    y1: 344.377,
    y2: 382.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6764,
    stopColor: "#a660cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    stopColor: "#8d51b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.565,
    x2: 171.565,
    y1: 374.954,
    y2: 400.787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f3f8a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3f8a"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(1 -.001 .001 1 142.423 78.864)",
    gradientUnits: "userSpaceOnUse",
    x1: 177.25,
    x2: 215.235,
    xlinkHref: "#lg5",
    y1: 265.612,
    y2: 303.598
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(1 -.001 .001 1 142.423 78.864)",
    gradientUnits: "userSpaceOnUse",
    x1: 195.868,
    x2: 195.868,
    xlinkHref: "#lg6",
    y1: 296.189,
    y2: 322.023
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(1 -.013 .013 1 -126.723 -82.626)",
    gradientUnits: "userSpaceOnUse",
    x1: 164.107,
    x2: 202.093,
    y1: 429.366,
    y2: 467.351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(1 -.013 .013 1 -126.723 -82.626)",
    gradientUnits: "userSpaceOnUse",
    x1: 182.725,
    x2: 182.725,
    y1: 459.943,
    y2: 485.776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    stopColor: "#016f46",
    stopOpacity: 0.687
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(1 -.03 .03 1 177.135 -87.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 238.76,
    x2: 276.745,
    y1: 440.331,
    y2: 478.317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62dbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08a9f1"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(1 -.03 .03 1 177.135 -87.941)",
    gradientUnits: "userSpaceOnUse",
    x1: 257.378,
    x2: 257.378,
    y1: 470.908,
    y2: 496.741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017bae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6303,
    stopColor: "#02678e",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025f80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m73.702 156.834-.063 205.432c-.006 10.468-5.373 18.952-11.989 18.948-6.616-.004-11.974-8.493-11.968-18.961l.063-205.432c.006-10.468 5.373-18.952 11.989-18.948 6.615.004 11.974 8.493 11.968 18.961z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.734 137.873c-6.616-.003-11.983 8.48-11.989 18.948l-.016 51.783 23.95 23.95.023-75.72c.006-10.468-5.353-18.957-11.968-18.961z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.575 156.834-.063 205.432c-.006 10.468-5.373 18.952-11.989 18.948-6.616-.004-11.974-8.493-11.968-18.961l.063-205.432c.006-10.468 5.373-18.952 11.989-18.948 6.615.004 11.973 8.493 11.968 18.961z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.583 137.873c-6.616-.003-11.983 8.48-11.989 18.948l-.016 51.179 23.95 23.95.023-75.116c.006-10.468-5.353-18.957-11.968-18.961z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.445 156.834-.063 205.432c-.006 10.468-5.373 18.952-11.989 18.948-6.616-.004-11.974-8.493-11.968-18.961l.063-205.432c.006-10.468 5.373-18.952 11.989-18.948 6.615.004 11.973 8.493 11.968 18.961z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.453 137.873c-6.616-.003-11.983 8.48-11.989 18.948l-.016 41.491 23.95 23.95.023-65.428c.006-10.468-5.353-18.957-11.968-18.961z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.318 156.834-.063 205.432c-.006 10.468-5.373 18.952-11.989 18.948-6.616-.004-11.974-8.493-11.968-18.961l.063-205.432c.006-10.468 5.373-18.952 11.989-18.948 6.615.004 11.973 8.493 11.968 18.961z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.326 137.873c-6.616-.003-11.983 8.48-11.989 18.948l-.016 46.304 23.95 23.95.023-70.241c.006-10.468-5.353-18.957-11.968-18.961z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m264.459 138.134h-18.919c-9.986 0-18.081 8.095-18.081 18.081v329.704c0 9.986 8.095 18.081 18.081 18.081h18.919c9.986 0 18.081-8.095 18.081-18.081v-329.704c0-9.986-8.095-18.081-18.081-18.081z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.459 138.134h-18.919c-9.986 0-18.081 8.095-18.081 18.081v43.785l55.081 55.081v-98.866c.001-9.986-8.095-18.081-18.081-18.081z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.54 395.437h-55.081v90.482c0 9.986 8.095 18.081 18.081 18.081h18.919c9.986 0 18.081-8.095 18.081-18.081z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m227.455 5.304-220.185 102.79c-2.649 1.237-1.832 5.109 1.103 5.223l26.897 1.051c146.428 5.723 293.032 5.723 439.46 0l26.897-1.051c2.935-.115 3.752-3.987 1.103-5.223l-220.185-102.79c-15.15-7.072-39.94-7.072-55.09 0z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.27 108.094c-2.649 1.237-1.832 5.109 1.103 5.223l26.896 1.051c146.428 5.723 293.032 5.723 439.46 0l26.896-1.051c2.935-.115 3.752-3.987 1.103-5.223l-118.81-55.465h-257.836z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.958 7.338-96.257 100.946c-1.158 1.215-.801 5.017.482 5.13l11.758 1.032c64.013 5.62 128.104 5.62 192.117 0l11.758-1.032c1.283-.113 1.64-3.915.482-5.13l-96.256-100.946c-6.623-6.945-17.461-6.945-24.084 0z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.817 113.414c1.283-.113 1.64-3.915.482-5.13l-53.07-55.655h-110.458l-53.07 55.655c-1.158 1.215-.801 5.017.482 5.13l11.758 1.032c64.013 5.62 128.104 5.62 192.117 0z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51 208.518c-28.167 0-51-22.833-51-51v-37.655c0-7.37 5.975-13.345 13.345-13.345h88.655v51c0 28.167-22.833 51-51 51z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153 208.518c-28.167 0-51-22.833-51-51v-51h102v51c0 28.167-22.833 51-51 51z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 208.518c-28.167 0-51-22.833-51-51v-51h102v51c0 28.167-22.833 51-51 51z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357 208.518c-28.167 0-51-22.833-51-51v-51h102v51c0 28.167-22.833 51-51 51z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459 208.518c-28.167 0-51-22.833-51-51v-51h88.655c7.37 0 13.345 5.975 13.345 13.345v37.655c0 28.167-22.833 51-51 51z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102 156.518v1c0 28.17-22.83 51-51 51s-51-22.83-51-51v-1z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204 156.518v1c0 28.17-22.83 51-51 51s-51-22.83-51-51v-1z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306 156.518v1c0 28.17-22.83 51-51 51s-51-22.83-51-51v-1z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 156.518v1c0 28.17-22.83 51-51 51s-51-22.83-51-51v-1z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 156.518v1c0 28.17-22.83 51-51 51s-51-22.83-51-51v-1z",
    fill: "url(#SVGID_25_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m388.389 476.998-13.916-47.898c-1.571-5.406-6.327-9.1-11.717-9.1h-215.511c-5.39 0-10.147 3.694-11.717 9.1l-13.916 47.898z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m121.611 476.999 266.778-.001-11.951-41.132h-242.876z",
    fill: "url(#SVGID_27_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 491.919v-21.919c0-9.986-8.095-18.081-18.081-18.081h-473.838c-9.986 0-18.081 8.095-18.081 18.081v21.919c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.095 18.081-18.081z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 483.095v8.824c0 9.986 8.095 18.081 18.081 18.081h473.838c9.986 0 18.081-8.095 18.081-18.081v-8.824z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 171.565,
    cy: 362.995,
    fill: "url(#SVGID_30_)",
    r: 42.944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.716 365.713c1.404 22.449 20.046 40.226 42.849 40.226s41.446-17.776 42.849-40.226z",
    fill: "url(#SVGID_31_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 338.435,
    cy: 362.995,
    fill: "url(#SVGID_32_)",
    r: 42.944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.587 365.734c1.415 22.449 20.066 40.215 42.869 40.204 22.803-.012 41.436-17.797 42.829-40.247z",
    fill: "url(#SVGID_33_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 61.692,
    cy: 362.995,
    fill: "url(#SVGID_34_)",
    r: 42.944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.881 366.258c1.689 22.43 20.556 39.967 43.358 39.677s41.216-18.302 42.333-40.768z",
    fill: "url(#SVGID_35_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 448.308,
    cy: 362.995,
    fill: "url(#SVGID_36_)",
    r: 42.944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.561 367.01c2.083 22.397 21.256 39.599 44.049 38.908s40.888-19.024 41.61-41.506z",
    fill: "url(#SVGID_37_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarousel);
export default __webpack_public_path__ + "static/media/icon-carousel.a394b53264b852d36e174257fece6fbe.svg";
export { ForwardRef as ReactComponent };